/**
 * ╔══════════════════════════════════════════════════════════════╗
 * ║              © 2026 Madar.iq — All Rights Reserved          ║
 * ║   This software is proprietary and confidential.            ║
 * ║   Unauthorized use, copying or distribution is prohibited.  ║
 * ╚══════════════════════════════════════════════════════════════╝
 */

// ── جميع الـ imports أولاً (ESLint requirement) ──────────────────
import "./protection/devtools-guard";
import { validateDomainLicense } from "./protection/license-validator";
import "./i18n";
import "./index.css";
import React from "react";
import { setupGlobalThemeFonts } from "./theme/ThemeConfigProvider";
import ReactDOM from "react-dom/client";
import { ChakraProvider, ColorModeScript } from "@chakra-ui/react";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import theme from "./admindashboard/context/ThemeContext";
import { SearchProvider } from "./admindashboard/context/SearchContext";
import { StoreProvider } from "./context/store/StoreProvider";
import { AuthProvider } from "./context/auth/AuthProvider";

// ── تشغيل التحقق من الترخيص فور بدء التطبيق ──────────────────
validateDomainLicense();

// Initialize Theme Assets new
setupGlobalThemeFonts();

const getSavedLang = () => {
  try {
    return window.localStorage.getItem("lang") || "en";
  } catch {
    return "en";
  }
};

const savedLang = getSavedLang();
document.documentElement.lang = savedLang;
document.documentElement.dir = savedLang === "ar" ? "rtl" : "ltr";
document.documentElement.style.setProperty("--webkit-tap-highlight-color", "transparent");

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ColorModeScript initialColorMode={theme.config.initialColorMode} />
    <ChakraProvider theme={theme}>
      <BrowserRouter>
        <AuthProvider>
          <StoreProvider>
            <SearchProvider>
              <App />
            </SearchProvider>
          </StoreProvider>
        </AuthProvider>
      </BrowserRouter>
    </ChakraProvider>
  </React.StrictMode>
);
